import { STRIPES, stripeBg } from "@/lib/stripes";
import { Checkbox } from "@/components/ui/checkbox";
import { useI18n } from "@/context/I18nContext";

export const Swatches = ({ value, onPick, prefix }) => (
  <div className="flex flex-wrap gap-1.5">
    {STRIPES.map((s) => (
      <button key={s.ref} type="button" title={s.label} aria-label={s.label} onClick={() => onPick(s.label)}
        data-testid={`${prefix}-${s.ref}`}
        className={`w-7 h-7 rounded border transition-transform hover:scale-110 ${value === s.label ? "ring-2 ring-offset-1 ring-[#c9a227] border-transparent" : "border-border"}`}
        style={{ background: stripeBg(s) }} />
    ))}
  </div>
);

export const StripePicker = ({ value, onPick, isDefault, bottom, onPickBottom, single, arch, onPickArch, archDefault }) => {
  const { t } = useI18n();
  return (
  <div className="pt-3 mt-3 border-t border-border" data-testid="stripe-picker">
    <div className="text-sm font-medium">{t("Couleur des bandes déco")}{bottom ? ` — ${t("bande du haut")}` : ""}</div>
    <div className="text-xs text-muted-foreground mb-2" data-testid="stripe-selected">
      {value}{isDefault ? ` (${t("par défaut")})` : ""}{bottom || single ? "" : ` · ${t("haut et bas identiques")}`}
    </div>
    <Swatches value={value} onPick={onPick} prefix="stripe" />
    {!single && (
    <label className="flex items-center gap-2 text-xs mt-3 cursor-pointer" data-testid="stripe-bottom-toggle">
      <Checkbox checked={!!bottom} onCheckedChange={(v) => onPickBottom(v ? value : "")} data-testid="stripe-bottom-check" />
      {t("Bande du bas d'une couleur différente")}
    </label>
    )}
    {bottom && !single && (
      <div className="mt-2" data-testid="stripe-bottom-picker">
        <div className="text-sm font-medium">{t("Bande du bas")}</div>
        <div className="text-xs text-muted-foreground mb-2" data-testid="stripe-bottom-selected">{bottom}</div>
        <Swatches value={bottom} onPick={onPickBottom} prefix="stripe-bottom" />
      </div>
    )}
    {arch && (
      <div className="mt-4" data-testid="arch-picker">
        <div className="text-sm font-medium">{t("Couleur des arches avant")}</div>
        <div className="text-xs text-muted-foreground mb-2" data-testid="arch-selected">{arch}{archDefault ? ` (${t("comme les bandes")})` : ""}</div>
        <Swatches value={arch} onPick={onPickArch} prefix="arch" />
      </div>
    )}
  </div>
  );
};
